import * as React from "react";
import Special from "../../_data/models/Special";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import UserProfileHeaderComponent from "../../_widgets/user/UserProfileHeaderComponent";
import LikeContainer from "../../_widgets/like/LikeContainer";
import BreadcrumbsComponent from "../../_widgets/breadcrumbs/BreadcrumbsComponent";

interface Props {
    loading: boolean;
    item: Special
}

const SpecialModalComponent = (props: Props) => {
    const {item, loading} = props;

    if (loading) {
        return <div><LoadingIndicatorComponent/></div>
    }

    if (!item) return null;

    return (
        <div>
            <div className="row">
                <BreadcrumbsComponent>
                    <li>
                        <a href="javascript: history.go(-1)">
                            Back
                        </a>
                    </li>
                    <li>View Special</li>
                </BreadcrumbsComponent>
            </div>

            <UserProfileHeaderComponent user={item.user}/>

            <div className="row">
                <div className="large-12 columns">
                    <div className="newsfeed-panel callout paddingless mb-half">
                        <div className="row p1">
                            <div className="large-12 columns paddingless bt-1 bb-1 p2 specials">
                                <div className="text-center">
                                    <h3>{item.title}</h3>
                                    <p style={{wordWrap: 'break-word'}}>{item.description}</p>
                                    <small>
                                        Starts on {item.prettyStartDate()}<br />
                                        <span>
                                            {item.prettyEndDateString()}
                                        </span>
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div className="row p1">
                            <div className="large-12 columns">
                                <ul className="list-inline marginless newsfeed-lgfont">
                                    <LikeContainer model={item}/>
                                </ul>
                            </div>
                        </div>

                        {/*<ul className="list-inline table justified">*/}
                        {/*<li className="text-center"><a href="#"><i className="fa fa-share"></i>&nbsp; Share</a></li>*/}
                        {/*<li className="text-center"><a href="edit-image.html"><i className="fa fa-edit"></i>&nbsp; Edit</a></li>*/}
                        {/*</ul>*/}
                    </div>

                </div>
            </div>
        </div>
    );
};
export default SpecialModalComponent;


// WEBPACK FOOTER //
// ./app/client/special/components/SpecialItemComponent.tsx